import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { get } from 'lodash';
import { updateReservation } from './_api';
import withLoader from '../app/withLoader';

const enhance = compose(
  withLoader,
  withHandlers({
    onSubmit: ({ item, setEditDiscountDialog, loadItem, toggleLoader }) => async values => {
      toggleLoader();
      const resp = await updateReservation(
        item.id,
        { discountPercentage: get(values, 'discountPercentage', 0) }
      );
      if (resp) {
        setEditDiscountDialog(false);
        await loadItem(item.id);
      }
      toggleLoader(false);
    },
  }),
  reduxForm({ form: 'editItem' }),
);

export default enhance((
{
    editDiscountDialog, setEditDiscountDialog,
    fullScreen, handleSubmit
}) => (
  <form onSubmit={handleSubmit}>
    <Dialog
      fullScreen={fullScreen}
      open={editDiscountDialog.open}
      onClose={() => setEditDiscountDialog({ open: false, title: '' })}
      aria-labelledby="responsive-dialog-title"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="responsive-dialog-title">Úprava slevy</DialogTitle>
      <DialogContent>
        <Grid container={true} spacing={16}>
          <Grid item={true} xs={6}>
            <Field
              name="discountPercentage"
              component={TextField}
              label="Sleva (%)"
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button type="submit" color="primary" variant="contained" onClick={handleSubmit} autoFocus>
          Uložit
        </Button>
        <Button
          onClick={() => setEditDiscountDialog({ open: false, title: '' })}
          color="secondary"
          variant="contained"
        >
          Zrušit
        </Button>
      </DialogActions>
    </Dialog>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/reservations/editDiscountDialog.js